const TOGGLE_LOADER = "TOGGLE_LOADER";
const ADDRESS_COMBO = "ADDRESS_COMBO";
const UPDATE_OPTIONS_FOR_STATE = "UPDATE_OPTIONS_FOR_STATE";
const RESET_ADDRESS_COMBO = "RESET_ADDRESS_COMBO";
const ADDRESS_FROM_GOOGLE = "ADDRESS_FROM_GOOGLE";

export const toggleLoader = () => ({ type: TOGGLE_LOADER });
export const addressCombo = payload => ({ type: ADDRESS_COMBO, payload });
export const addressFromGoogle = payload => ({ type: ADDRESS_FROM_GOOGLE, payload });
export const updateOptionsForState = payload => ({ type: UPDATE_OPTIONS_FOR_STATE, payload });
export const resetAddressCombo = () => ({ type: RESET_ADDRESS_COMBO });

const appInitState = {
  loader: false,
  googleAddress: {},
  options: [],
  state: "",
};

export default function appReducer(state = appInitState, action) {
  switch (action.type) {
    case TOGGLE_LOADER:
      return { ...state, ...{ loader: !state.loader } };
    case ADDRESS_COMBO:
      return { ...state, ...action.payload };
    case RESET_ADDRESS_COMBO:
      return { ...appInitState };
    case UPDATE_OPTIONS_FOR_STATE:
      return { ...state, ...action.payload };
    case ADDRESS_FROM_GOOGLE:
      return { ...state, ...{ googleAddress: action.payload } };
    default:
      return state;
  }
}
